import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreInfluencerTicketApi extends BaseApi {
  async getInfluencerTicketList(
    parameters: APIPaths["/store-app/influencer-ticket/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/store-app/influencer-ticket/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (
      await this.get("/store-app/influencer-ticket/list", {
        params: parameters,
      })
    ).data;
  }
  async getInfluencerTicketListMinimal(
    parameters: APIPaths["/store-app/influencer-ticket/list-minimal"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/list-minimal"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get("/store-app/influencer-ticket/list-minimal", {
        params: parameters,
      })
    ).data;
  }
  async getInfluencerTicketById(
    id: APIPaths["/store-app/influencer-ticket/{id}"]["get"]["parameters"]["path"]["id"],
  ): Promise<APIPaths["/store-app/influencer-ticket/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/store-app/influencer-ticket/${id}`)).data;
  }
  async putInfluencerTicketRejectionById(
    id: APIPaths["/store-app/influencer-ticket/{id}/request-rejection"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/request-rejection"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/request-rejection`)).data;
  }
  async putInfluencerTicketApprovalById(
    id: APIPaths["/store-app/influencer-ticket/{id}/request-approval"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/request-approval"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/request-approval`)).data;
  }
  async putInfluencerTicketListRejection(
    requestBody: APIPaths["/store-app/influencer-ticket/list/request-rejection"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/list/request-rejection"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/list/request-rejection`, requestBody)).data;
  }
  async putInfluencerTicketListApproval(
    requestBody: APIPaths["/store-app/influencer-ticket/list/request-approval"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/list/request-approval"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/list/request-approval`, requestBody)).data;
  }
  async putInfluencerTicketPriorityById(
    id: APIPaths["/store-app/influencer-ticket/{id}/priority"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/priority"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/priority"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/priority`, requestBody)).data;
  }
  async deleteInfluencerTicketPriorityById(
    id: APIPaths["/store-app/influencer-ticket/{id}/priority"]["delete"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/priority"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(`/store-app/influencer-ticket/${id}/priority`)).data;
  }
  async putInfluencerTicketPinById(
    id: APIPaths["/store-app/influencer-ticket/{id}/pin"]["put"]["parameters"]["path"]["id"],
    parameters?: APIPaths["/store-app/influencer-ticket/{id}/pin"]["put"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/pin"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.put(`/store-app/influencer-ticket/${id}/pin`, undefined, {
        params: parameters,
      })
    ).data;
  }
  async deleteInfluencerTicketPinById(
    id: APIPaths["/store-app/influencer-ticket/{id}/pin"]["delete"]["parameters"]["path"]["id"],
    parameters?: APIPaths["/store-app/influencer-ticket/{id}/pin"]["delete"]["parameters"]["query"],
  ): Promise<void> {
    return (
      await this.delete(`/store-app/influencer-ticket/${id}/pin`, {
        params: parameters,
      })
    ).data;
  }
  async putInfluencerTicketCancelById(
    id: APIPaths["/store-app/influencer-ticket/{id}/cancel"]["put"]["parameters"]["path"]["id"],
    requestBody?: APIPaths["/store-app/influencer-ticket/{id}/cancel"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/cancel"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/cancel`, requestBody ?? {})).data;
  }
  async putInfluencerTicketDeliveryById(
    id: APIPaths["/store-app/influencer-ticket/{id}/delivery"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/delivery"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/delivery`)).data;
  }
  async putInfluencerTicketCheckById(
    id: APIPaths["/store-app/influencer-ticket/{id}/check"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/check"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/check`)).data;
  }
  async putInfluencerTicketRatingById(
    id: APIPaths["/store-app/influencer-ticket/{id}/rating"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/rating"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/rating"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/rating`, requestBody)).data;
  }
  async postInfluencerTicketChatReportById(
    id: APIPaths["/store-app/influencer-ticket/{id}/chat-report/new"]["post"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/chat-report/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/chat-report/new"]["post"]["responses"]["201"]["content"]["application/json"]
  > {
    return (await this.post(`/store-app/influencer-ticket/${id}/chat-report/new`, requestBody)).data;
  }
  async getInfluencerTicketChatReportList(
    id: APIPaths["/store-app/influencer-ticket/{id}/chat-report/list-all"]["get"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/chat-report/list-all"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer-ticket/${id}/chat-report/list-all`)).data;
  }
  async postInfluencerTicketNotifyChatMessage(
    id: APIPaths["/store-app/influencer-ticket/{id}/notify-chat-message"]["post"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/notify-chat-message"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths> {
    return (await this.post(`/store-app/influencer-ticket/${id}/notify-chat-message`, requestBody)).data;
  }
  async putInfluencerTicketMemoById(
    id: APIPaths["/store-app/influencer-ticket/{id}/memo"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/memo"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/memo"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/memo`, requestBody)).data;
  }
  async putInfluencerTicketUseCancelById(
    id: APIPaths["/store-app/influencer-ticket/{id}/use-cancel"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/use-cancel"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/use-cancel`)).data;
  }
  async putInfluencerTicketReserveById(
    id: APIPaths["/store-app/influencer-ticket/{id}/reserve"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/influencer-ticket/{id}/reserve"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/reserve"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/reserve`, requestBody)).data;
  }
  async deleteInfluencerTicketReserveById(
    id: APIPaths["/store-app/influencer-ticket/{id}/reserve"]["delete"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/reserve"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(`/store-app/influencer-ticket/${id}/reserve`)).data;
  }
  async deleteInfluencerTicketCancelById(
    id: APIPaths["/store-app/influencer-ticket/{id}/cancel"]["delete"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/cancel"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(`/store-app/influencer-ticket/${id}/cancel`)).data;
  }
  async deleteInfluencerTicketById(
    id: APIPaths["/store-app/influencer-ticket/{id}"]["delete"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.delete(`/store-app/influencer-ticket/${id}`)).data;
  }
  async putInfluencerTicketUseById(
    id: APIPaths["/store-app/influencer-ticket/{id}/use"]["put"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/use"]["put"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.put(`/store-app/influencer-ticket/${id}/use`)).data;
  }

  async getInfluencerTicketStatusLogList(
    id: APIPaths["/store-app/influencer-ticket/{id}/status-log/list-all"]["get"]["parameters"]["path"]["id"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/{id}/status-log/list-all"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get(`/store-app/influencer-ticket/${id}/status-log/list-all`)).data;
  }

  async getInfluencerTicketPostList(
    parameters: APIPaths["/store-app/influencer-ticket/post/list"]["get"]["parameters"]["query"],
  ): Promise<
    APIPaths["/store-app/influencer-ticket/post/list"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (
      await this.get("/store-app/influencer-ticket/post/list", {
        params: parameters,
      })
    ).data;
  }
}
